import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchFacetData } from '#/modules/search/types/SearchFacetData';
import {
  VOLOP_FUNCTIONS,
  VolopFunction,
} from '#/utils/constants/general/volopFunctions';

export function volopKeywordsFacet(i18n: I18nFn) {
  return {
    id: 'volopKeywordsFacet',
    name: 'functions',
    get title() {
      return i18n('Skills');
    },
    type: 'array',
    options: Object.keys(VolopFunction),
    optionTitles: VOLOP_FUNCTIONS(i18n),
  } as const satisfies SearchFacetData;
}
